<template>
    <div v-if="loading">Loading...</div>
    <div v-else class="interview-transcript-tab">
        <div class="interview-contents">
            <ul>
                <li v-for="(item, index) in transcript" :key="index">
                    <a class="primary" :href="`#question-${index + 1}`">
                        <EditorText :value="item.question" />
                    </a>
                </li>
            </ul>
        </div>

        <div class="interview-transcript">
            <div v-for="(item, index) in transcript" :key="index" :id="`question-${index + 1}`">
                <EditorText class="interview-question" :value="item.question" />
                <EditorText class="interview-answer" :value="item.answer" />
            </div>
            <div v-if="transcript.length === 0">There are no questions in this transcript.</div>
        </div>
    </div>
</template>

<script>
import { InterviewQuestionService } from '@/services/interviewQuestionService'
import EditorText from '@/components/inputs/RichTextEditor/EditorText'

export default {
    name: 'InterviewModalTranscriptTab',
    components: { EditorText },
    props: {
        interview: {
            type: Object,
            required: true,
        },
    },
    computed: {
        loading() {
            return this.$asyncComputed.transcript.updating
        },
    },
    watch: {
        transcript() {
            this.$nextTick(() => this.scrollToFirstHighlight())
        },
    },
    asyncComputed: {
        transcript: {
            async get() {
                if (!this.interview.id) {
                    return []
                }

                if (this.interview.questions && this.interview.questions.length > 0) {
                    return this.interview.questions
                }

                return await InterviewQuestionService.list(this.interview.id)
            },
            default() {
                return []
            },
        },
    },

    methods: {
        scrollToFirstHighlight() {
            this.$el.querySelector('.search-result-highlight')?.scrollIntoView()
        },
        truncate(s, n) {
            return s.substring(0, n) + (s.length > n ? '...' : '')
        },
    },
}
</script>

<style>
.interview-transcript-tab {
    display: flex;
    flex-direction: row;
}

.interview-contents {
    flex-basis: 25%;
    margin-right: 24px;

    ul {
        list-style-type: none;
    }

    li {
        overflow: hidden;
        text-overflow: ellipsis;
        display: -webkit-box;
        line-height: 21px;
        max-height: 48px;
        line-clamp: 2;
        -webkit-line-clamp: 2;
        -webkit-box-orient: vertical;

        font-weight: 700;

        margin-bottom: 16px;

        .editor-content-rendered {
            font-size: 14px;
        }
    }
}

.interview-transcript {
    flex-basis: 75%;
}

.interview-question {
    margin-bottom: 8px;
    font-weight: bold;

    &,
    &.editor-content-rendered,
    &.editor-content-rendered p {
        font-size: 18px;
    }
}

.interview-answer {
    margin-bottom: 32px;
}
</style>
